
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import "bootstrap/dist/css/bootstrap.css";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
  UncontrolledCollapse
} from "reactstrap";
import Map from "./Map";
import PoemLine from './PoemLine';
import createHistory from "history/createBrowserHistory"
import LoadingSpinner from './LoadingSpinner'
import { withRouter } from "react-router-dom";
import TagDialog from './TagDialog'
import TagsLegends from './TagsLegends'
import TagPhotosDialog from './TagPhotosDialog';
import FamilyTreeDialog from './FamilyTreeDialog'

class PoemPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      poem: null,
      loaded: false,
      open: false,
      showTagDialog: null,
      selectedTagId: null,
      tagPhotoDialogVisible: false,
      selectedTagPhotoIndex: null, 
      selectedTagPhotos: null,
      familyTreeDialogVisible: false

        };
    this.renderData = this.renderData.bind(this);
    this.showTag = this.showTag.bind(this);
    this.tagDialogClosed = this.tagDialogClosed.bind(this);
    this.openPhotosDialog = this.openPhotosDialog.bind(this);
    this.tagPhotosDialogClosed = this.tagPhotosDialogClosed.bind(this);
    this.familyTreeDialogClosed = this.familyTreeDialogClosed.bind(this);
    this.openFamilyTreeDialog = this.openFamilyTreeDialog.bind(this);
  }
  componentDidMount() {

    window.poemPage = this;
    const comp = this;
    fetch(
      "http://www.almotanabbi.com/ws1.0/getPoem.do?poemId=" + this.props.match.params.poemId
    ).then(response => {
      response.json().then(poem => {
        comp.setState({ open: true, loaded: true, poem: poem });
      });
    });
  }


  showTag(tagId) {
    this.setState({showTagDialog:true, selectedTagId: tagId})
  }

  tagDialogClosed() {
    this.setState({showTagDialog:null});
  }

  render() {
    if(!this.state.loaded) {
      return <LoadingSpinner visible={true}/>;
    }

    return this.renderData();
  }

  openPhotosDialog(selectedTagPhotos, index){
    this.setState({showTagDialog:false, tagPhotoDialogVisible: true, selectedTagPhotos: selectedTagPhotos, selectedTagPhotoIndex: index});
  }

  openFamilyTreeDialog(){
    this.setState({showTagDialog:false, familyTreeDialogVisible: true});
  }
  
  
  tagPhotosDialogClosed() {
    this.setState({tagPhotoDialogVisible: false});
    this.setState({showTagDialog:true});
  }

  familyTreeDialogClosed() {
    this.setState({familyTreeDialogVisible: false});
    this.setState({showTagDialog:true});
  }

  renderData() {

    return (
      <div style={{width:'100%'}}>
    {this.state.familyTreeDialogVisible && <FamilyTreeDialog tagId={this.state.selectedTagId} dialogClosed={this.familyTreeDialogClosed}/>}
    {this.state.tagPhotoDialogVisible && <TagPhotosDialog selectedTagPhotos={this.state.selectedTagPhotos} selectedIndex={this.state.selectedTagPhotoIndex} tagPhotosDialogClosed={this.tagPhotosDialogClosed}/>}

          <Button color="primary" onClick={() => {this.props.history.goBack()}}>
          رجوع
        </Button>
        <center>
  <div style={{textAlign:'center'}}>
          <h2>{this.state.poem.poemTitle}</h2>
<br/>
          {this.state.poem.description && (
                <div>مناسبة القصيدة: {this.state.poem.description}</div>
              )}
              <br />
              {this.state.poem.lines.map(line => <PoemLine line={line} />)}

              </div>
              </center>

              {this.state.showTagDialog && <TagDialog tagId={this.state.selectedTagId} dialogClosed={window.poemPage.tagDialogClosed} openFamilyTreeDialog={this.openFamilyTreeDialog} openPhotosDialog={this.openPhotosDialog} />}
              <hr/>
              <TagsLegends lines={this.state.poem.lines}/>
      </div>
      
    );
  }
}

export default withRouter(PoemPage);


// WEBPACK FOOTER //
// ./src/PoemPage.js